import { createStoreSelector } from "../selectors";
export const selectHistory = (state) => createStoreSelector(state, "history")(state);
//# sourceMappingURL=history.selectors.js.map